module.exports = __webpack_public_path__ + "img/jcry.b0479892.svg";